import React from 'react';
import ThirdHeading from "../ThirdHeading/ThirdHeading";
import './ObtainedFood.styles.scss';

function ObtainedFood({ data }) {
    return (
        <div className="obtained-food">
            {data.map((item, inx) => (
                <div key={inx} className="obtained-food__item">
                   <div className="obtained-food__title">
                       <ThirdHeading>{item.name}</ThirdHeading>
                   </div>
                   <div className="obtained-food__percents">{item.value}%</div>
                </div>
            ))}
        </div>
    );
}

export default ObtainedFood;